<template lang="pug">
.button-tab(:class="{ selected, modified }")
  .toggler(@click="toggle")
    slot(name="title")
  transition(name="fade")
    .tab-content(:class="{ modified }")
      slot(name="content")
</template>
<script>
import { vuexComputed } from '@/helpers';
export default {
  name: 'button-tab',
  props: { id: { type: String, required: true } },
  computed: {
    ...vuexComputed('selectedToggler'),
    selected() {
      return this.id === this.selectedToggler;
    },
    modified() {
      const {
        id,
        $store: { getters }
      } = this;
      let [namespace, key] = id.split(/\//);
      if (!/\//.test(id)) {
        key = namespace;
        namespace = '';
      } else if (namespace) {
        namespace += '/';
      }
      const d = getters[namespace + 'default_' + key];
      // todo: modify to handle strings and arrays
      const current = getters[namespace + key];
      return current?.join ? current?.join('|') !== (d?.join && d.join('|')) : d !== null && current !== d;
    }
  },
  methods: {
    toggle() {
      const { id, selectedToggler } = this;
      this.selectedToggler = (selectedToggler !== id && id) || null;
    }
  }
};
</script>
<style scoped lang="scss">
.button-tab {
  position: relative;
  margin-right: 0.5rem;
  &.selected {
    .toggler {
      border-color: #aaa;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom-color: transparent;
      padding-bottom: 0.8rem;
      box-shadow: 0 0 2px black;
      &::before {
        content: '\00a0';
        background-color: white;
        position: absolute;
        left: 0;
        width: calc(100% - 2px);
        top: 100%;
        margin-top: -9px;
        height: 2px;
        z-index: 12;
        border: 1px solid #ccc;
        border-top-width: 0;
        border-bottom-width: 0;
      }
    }
    .tab-content {
      z-index: 10;
      opacity: 1;
      pointer-events: all;
    }
  }
  &.modified:not(.no-dot) {
    .toggler {
      &::after {
        position: absolute;
        content: '\00a0';
        background-color: orange;
        height: 0.57rem;
        width: 0.6rem;
        border-radius: 0.25rem;
        z-index: 13;
        right: 0.2rem;
        top: 0.2rem;
      }
    }
  }
  * {
    box-sizing: border-box;
  }
  .toggler {
    cursor: pointer;
    text-transform: capitalize;
    padding: 0.3rem 1rem 0.3rem 0.7rem;
    border: 1px solid orange;
    box-shadow: 0 0 2px orange;
    font-weight: bold;
    color: #555;
    width: auto;
    border-radius: 0.25rem;
    z-index: 11;
  }
  .tab-content {
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: -8px;
    padding: 1.5rem;
    padding-top: 3rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem;
    box-shadow: 0 1px 3px black;
    min-width: 20rem;
    background-color: white;
  }
  &:not(.right) {
    .tab-content {
      border-top-left-radius: 0;
    }
  }
  &.right {
    .tab-content {
      right: 0;
      left: auto;
      border-top-right-radius: 0;
    }
  }
  &.white {
    .toggler,
    .tab-content {
      background-color: white;
    }
  }
  &.tall {
    &.toggler {
      padding: 0.3rem;
    }
    &.selected {
      .toggler {
        /*padding-bottom: 1rem;*/
      }
    }
    .tab-content {
      /*margin-top: 5px;*/
    }
  }
}
</style>
